"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaDropdownToggle = _interopRequireDefault(require("@thinkific/toga-dropdown-toggle"));

var _togaDropdown = require("@thinkific/toga-dropdown");

var _togaIcon = _interopRequireWildcard(require("@thinkific/toga-icon"));

var _constants = require("./constants");

var _InlineActions = _interopRequireDefault(require("./InlineActions.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_InlineActions["default"]);

var InlineActions = /*#__PURE__*/function (_Component) {
  _inherits(InlineActions, _Component);

  var _super = _createSuper(InlineActions);

  function InlineActions(props) {
    var _this;

    _classCallCheck(this, InlineActions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onHoverHandler", function (hasFocus) {
      return function (e) {
        e.stopPropagation();

        _this.setState({
          hasFocus: hasFocus
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuItemClick", function (onClickHandler) {
      return function () {
        _this.setState({
          isOpen: false
        });

        onClickHandler();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleHandler", function (open) {
      _this.setState({
        isOpen: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getMainAction", function () {
      var actions = _this.props.actions;
      return actions.filter(function (action) {
        return action.asButton;
      });
    });

    _this.onHoverHandler = _this.onHoverHandler.bind(_assertThisInitialized(_this));
    _this.onMenuItemClick = _this.onMenuItemClick.bind(_assertThisInitialized(_this));
    _this.onToggleHandler = _this.onToggleHandler.bind(_assertThisInitialized(_this));
    _this.state = {
      hasFocus: props.hasFocus,
      isOpen: false
    };
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(InlineActions, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var hasFocus = nextProps.hasFocus;
      this.setState({
        hasFocus: hasFocus
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this2 = this;

      var _this$props = this.props,
          buttonAppearance = _this$props.buttonAppearance,
          forceMainActionOpen = _this$props.forceMainActionOpen;
      var _this$state = this.state,
          hasFocus = _this$state.hasFocus,
          isOpen = _this$state.isOpen;
      var actionClasses = cx('action-button', {
        active: forceMainActionOpen || hasFocus || isOpen
      });
      return this.getMainAction().map(function (action) {
        return /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: buttonAppearance,
          className: actionClasses,
          isDisabled: action.isDisabled,
          key: action.name,
          onBlur: _this2.onHoverHandler(false),
          onClick: action.onClick,
          onFocus: _this2.onHoverHandler(true),
          onMouseOut: _this2.onHoverHandler(false),
          onMouseOver: _this2.onHoverHandler(true)
        }, action.name);
      });
    }
  }, {
    key: "renderMoreActions",
    value: function renderMoreActions() {
      var _this3 = this;

      var _this$props2 = this.props,
          buttonAppearance = _this$props2.buttonAppearance,
          icon = _this$props2.icon,
          actions = _this$props2.actions,
          alignment = _this$props2.alignment,
          forceMainActionOpen = _this$props2.forceMainActionOpen,
          isCompactMode = _this$props2.isCompactMode;
      var _this$state2 = this.state,
          hasFocus = _this$state2.hasFocus,
          isOpen = _this$state2.isOpen;
      var isActionActive = forceMainActionOpen || hasFocus || isOpen;
      var deleteActions = actions.filter(function (action) {
        return action.type === _constants.DANGER_TYPE;
      });
      var upgradeActions = actions.filter(function (action) {
        return action.type === _constants.UPGRADE_TYPE;
      });
      var nonSpecializedActions = actions.filter(function (action) {
        return !action.asButton && action.type !== _constants.DANGER_TYPE && action.type !== _constants.UPGRADE_TYPE;
      });
      var hasMainAction = this.getMainAction().length > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('ellipsis-button')
      }, /*#__PURE__*/_react["default"].createElement(_togaDropdown.Dropdown, {
        isOpen: isOpen,
        toggleListener: this.onToggleHandler
      }, /*#__PURE__*/_react["default"].createElement(_togaDropdownToggle["default"], {
        appearance: buttonAppearance,
        className: cx('inline-actions--toggle', {
          'inline-actions--active-toggle': isActionActive,
          'button--secondary': isActionActive,
          'compact-mode': isCompactMode,
          'has-main-action': !isCompactMode && hasMainAction
        }),
        icon: icon,
        showCaret: false,
        onBlur: this.onHoverHandler(false),
        onFocus: this.onHoverHandler(true),
        onMouseOut: this.onHoverHandler(false),
        onMouseOver: this.onHoverHandler(true)
      }), /*#__PURE__*/_react["default"].createElement(_togaDropdown.Menu, {
        position: alignment
      }, isCompactMode && this.getMainAction().map(function (action) {
        return /*#__PURE__*/_react["default"].createElement(_togaDropdown.Item, {
          key: action.name,
          title: action.text,
          onClick: _this3.onMenuItemClick(action.onClick)
        }, /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('inline-actions__more-actions--button'),
          isDisabled: action.isDisabled
        }, action.text));
      }), nonSpecializedActions.map(function (action) {
        return /*#__PURE__*/_react["default"].createElement(_togaDropdown.Item, {
          className: cx('inline-actions__item'),
          key: action.name,
          title: action.text,
          onClick: _this3.onMenuItemClick(action.onClick)
        }, !action.iconLeft && !action.iconRight && /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('inline-actions__more-actions--button'),
          isDisabled: action.isDisabled
        }, action.text), action.iconRight && /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('inline-actions__more-actions--button'),
          isDisabled: action.isDisabled
        }, action.text, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
          className: cx('inline-actions__more-actions--button__icon-right'),
          name: action.iconRight,
          "aria-hidden": true
        })), action.iconLeft && /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('inline-actions__more-actions--button'),
          isDisabled: action.isDisabled
        }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
          className: cx('inline-actions__more-actions--button__icon-left'),
          name: action.iconLeft,
          "aria-hidden": true
        }), action.text));
      }), upgradeActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, nonSpecializedActions.length > 0 && /*#__PURE__*/_react["default"].createElement("hr", {
        className: cx('inline-actions__separator')
      }), upgradeActions.map(function (upgradeAction) {
        return /*#__PURE__*/_react["default"].createElement(_togaDropdown.Item, {
          className: cx('inline-actions__item', 'inline-actions__item--upgrade', 'dropdown'),
          key: upgradeAction.name,
          title: upgradeAction.text,
          onClick: upgradeAction.onClick
        }, /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('dropdown-menu__item', 'dropdown-menu__item--upgrade')
        }, /*#__PURE__*/_react["default"].createElement("span", null, upgradeAction.name), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
          className: cx('dropdown-menu__item__description', 'caption')
        }, upgradeAction.text), /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('dropdown-menu__item--upgrade-button')
        }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
          className: cx('dropdown-menu__item--upgrade-icon'),
          name: "upgrade"
        }), /*#__PURE__*/_react["default"].createElement("span", null, "Upgrade now")))));
      })), deleteActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isCompactMode || (upgradeActions.length > 0 || nonSpecializedActions.length > 0) && /*#__PURE__*/_react["default"].createElement("hr", {
        className: cx('inline-actions__separator')
      }), deleteActions.map(function (deleteAction) {
        return /*#__PURE__*/_react["default"].createElement(_togaDropdown.Item, {
          className: cx('inline-actions__item', 'dropdown'),
          key: deleteAction.name,
          title: deleteAction.text,
          onClick: deleteAction.onClick
        }, /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('dropdown-menu__item', 'dropdown-menu__item--danger'),
          hasDanger: true
        }, deleteAction.text));
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          alignment = _this$props3.alignment,
          isCompactMode = _this$props3.isCompactMode,
          wrapperClass = _this$props3.wrapperClass;
      var containerClasses = cx('inline-actions__container', "inline-actions__container-".concat(alignment), wrapperClass);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClasses
      }, alignment === 'right' && !isCompactMode && this.renderActions(), this.renderMoreActions(), alignment === 'left' && !isCompactMode && this.renderActions());
    }
  }]);

  return InlineActions;
}(_react.Component);

InlineActions.propTypes = {
  /** Array of the possible actions */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** Flag to show as button instead of within toggle menu */
    asButton: _propTypes["default"].bool,

    /** icon appears on the left of the action if icon is needed */
    iconLeft: _propTypes["default"].oneOf(_togaIcon.availableIcons),

    /** icon appears on the right of the action if icon is needed */
    iconRight: _propTypes["default"].oneOf(_togaIcon.availableIcons),

    /** Name of action (appears as button text) */
    name: _propTypes["default"].string.isRequired,

    /** More detailed text to display for action (appears in action menu) */
    text: _propTypes["default"].string.isRequired,

    /** Handler when action is clicked */
    onClick: _propTypes["default"].func.isRequired
  })).isRequired,

  /** Alignment of the menu and buttons with the toggle */
  alignment: _propTypes["default"].oneOf(['left', 'right']),

  /** Button appearance */
  buttonAppearance: _propTypes["default"].oneOf(['primary', 'secondary', 'knockout']),

  /** For the main action to be shown * */
  forceMainActionOpen: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Flag to indicate component is in focus */
  hasFocus: _propTypes["default"].bool,

  /** Icon for menu toggle */
  icon: _propTypes["default"].string,

  /** Toggles the compact version * */
  isCompactMode: _propTypes["default"].bool,

  /** Add classes to the wrapper container * */
  wrapperClass: _propTypes["default"].string
};
InlineActions.defaultProps = {
  buttonAppearance: 'secondary',
  hasFocus: false,
  icon: 'ellipsis-v',
  alignment: 'right',
  forceMainActionOpen: false,
  isCompactMode: false,
  wrapperClass: null
};
var _default = InlineActions;
exports["default"] = _default;